<template>
  <card-container
    :id="pageId"
    :class="pageId"
    :is-loading="status.isLoading"
    :disabled="status.isLoading"
    loading-message="Pulling up Receipt..."
    @submit="submitForm"
    @reset="resetForm"
  >
    <template #title>
      Pull Up Receipt
    </template>

    <template #content>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Order Id* </label>
        <div class="col-sm-7">
          <sanitized-input
            :id="`orderId-${pageId}`"
            v-model="orderId"
            placeholder="Order ID"
            required
          />
        </div>
      </div>
    </template>

    <message-html
      v-if="status.resultHtml"
      :result-html="status.resultHtml"
      :class="status.isReceiptContent ? 'success' : ''"
    />
    <template #submit-button>
      Get Receipt
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';

import util from '@/Utils/util';
import { useGlobal } from '@/use/global';
import { sendPost } from '@/Utils/api';

const pageId = 'pull-up-delivery-receipt';

export default {
  name: 'PullUpDeliveryReceipt',

  setup: () => {
    const { lastFormData, setFormData } = useGlobal(pageId);

    const orderId = ref('');

    const status = reactive({
      isLoading: false,
      isReceiptContent: false,
      resultHtml: '',
    });

    const submitForm = async () => {
      status.resultHtml = '';
      status.isLoading = true;
      try {
        const response = await sendPost('getDeliveryReceipt', {
          orderId: orderId.value,
        });
        status.resultHtml = response.data || '';
        status.isReceiptContent = true;
      } catch (error) {
        status.isReceiptContent = false;
        status.resultHtml = util.getErrorResponse(error);
      }
      status.isLoading = false;
    };

    const resetForm = () => {
      status.isReceiptContent = false;
      status.resultHtml = '';
      orderId.value = '';
    };

    onMounted(() => {
      orderId.value = lastFormData.value?.orderId || '';
    });

    onBeforeUnmount(() => {
      setFormData({
        orderId: orderId.value,
      });
    });

    return {
      pageId,
      orderId,
      status,

      submitForm,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
.pull-up-delivery-receipt {
  .success {
    .result-message {
      white-space: normal;
      padding-bottom: 10px;
      main {
        text-align: left !important;
      }
      .contact-info {
        color: #252422 !important;
      }
    }
  }
}
</style>
